import { z } from 'zod'

import { viewUiComponentSchema } from '../ui/component.ts'
import { viewUiComponentTypeSchema } from '../ui/enum.ts'
import { nodePropertyNameSchema } from './common.ts'
import { queryFieldSchemaForOverride } from './field.ts'
import { viewConfigFilterNodeSchema } from './filter.ts'
import { viewConfigTreeNodeSchema } from './tree.ts'

const viewConfigUiComponentSchema = z.object({
  componentType: viewUiComponentTypeSchema.optional(), // propertyがあれば、自動推論する。それ以外で必須
  property: nodePropertyNameSchema.optional(), // 必ずしもpropertyをもたない
  nodeName: z.string().optional(), // ChildRecordsFormでnodeNameが必要なので…
  get children() {
    return viewConfigUiComponentSchema.array().optional()
  },
  override: z
    .object({
      component: viewUiComponentSchema.optional(),
      queryField: queryFieldSchemaForOverride.optional(),
    })
    .optional(),
})
export type ViewConfigUiComponent = z.infer<typeof viewConfigUiComponentSchema>

export const ViewConfigFormSchema = z.object({
  type: z.literal(`form`),
  tree: viewConfigTreeNodeSchema.optional(), // 未設定のとき、プロパティは存在しない。設定済みの時は必須
  filterTree: viewConfigFilterNodeSchema.optional(),
  components: viewConfigUiComponentSchema.array().optional(), // 同上
})
export type ViewConfigForm = z.infer<typeof ViewConfigFormSchema>
